import { AgentChat } from '../components/agent-chat';

export default function Agent() {
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <AgentChat />
    </div>
  );
}
